<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'KickoffMeetingDisplay',
})
</script>
<template>
  <template v-if="data">
    <Descriptions layout="vertical" :column="{ xxl: 4, xl: 3, lg: 2, md: 1, sm: 1, xs: 1 }" size="middle">
      <Descriptions.Item label="会议时间">
        {{ data?.meetingTime }}
      </Descriptions.Item>
      <Descriptions.Item label="会议地点">
        {{ data?.meetingAddress }}
      </Descriptions.Item>
    </Descriptions>
    <Descriptions layout="vertical" :column="1" size="middle">
      <Descriptions.Item label="会议纪要">
        {{ data?.meetingSummary }}
      </Descriptions.Item>
      <Descriptions.Item label="附件">
        <FileDisplayNormals :fileList="data?.meetingFiles" />
      </Descriptions.Item>
    </Descriptions>
  </template>
  <Empty v-else description="暂无填报" />
</template>

<script lang="ts" setup name="KickoffMeetingDisplay">
import { Descriptions, Empty } from 'ant-design-vue'
import { FileDisplayNormals } from '-/Common/FileDisplay'
defineProps<{
  data?: ApiKickoffMeeting.Item
}>()
</script>
